import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { isString } from 'core/utils';
import { IPart } from 'parts/types';

const PartNumberHelper = {
  toValue: (partNumber: string | null): string | null => {
    if (!partNumber || !isString(partNumber)) {
      return null;
    }

    return partNumber.replace(/ /g, '_');
  },

  toLabel: (partNumber: string | null): string | null => {
    if (!partNumber || !isString(partNumber)) {
      return null;
    }

    return partNumber.replace(/_/g, ' ');
  },

  areTheSame: (firstPartNumber: string | null, secondPartNumber: string | null): boolean => {
    const firstValue = PartNumberHelper.toValue(firstPartNumber);
    const secondValue = PartNumberHelper.toValue(secondPartNumber);

    return firstValue === secondValue;
  },

  getDisplayedPartNumber: (part: IPart) => {
    if (1 === part?.generic) {
      return DEFAULT_PLACEHOLDER;
    }

    return PartNumberHelper.toLabel(part?.number);
  },
};

export default PartNumberHelper;
